import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dropdownSearch'
})
export class DropdownSearchPipe implements PipeTransform {

  transform(array: any[], query: string, column: any): any {
   
    if (query) {
      query = query.toLowerCase();
      return array.filter((value: any) =>
        value[column].toLowerCase().indexOf(query) > -1);
    }
    return array;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src2008182461/src/src/app/shared/pipes/dropdown-search.pipe.ts